import React from "react";
import { ShoppingCartIcon } from "../../icons/shoppingCart.icon";
import RecycleIcon from "../../icons/recycle.icon";
import GraduationCapIcon from "../../icons/graduationCap.icon";

// Interface definition for our feature items
interface ServiceFeature {
  Icon: React.ComponentType<{ className?: string; strokeWidth?: number }>;
  text: string;
  href: string;
}

const ServiceFeatures = () => {
  // Features array with proper typing for better maintainability
  const features: ServiceFeature[] = [
    {
      Icon: ShoppingCartIcon,
      text: "購物攻略",
      href: "/article/shopping-guide",
    },
    {
      Icon: RecycleIcon,
      text: "回收須知",
      href: "/article/recycle",
    },
    {
      Icon: GraduationCapIcon,
      text: "產品教學",
      href: "/article/product-tutorial",
    },
  ];

  return (
    <section className="py-8 md:py-16 bg-white">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="relative flex justify-between items-stretch">
          {features.map(({ Icon, text, href }, index) => (
            <a
              key={text}
              href={href}
              className={`
                flex-1 flex flex-col items-center justify-center 
                py-6 md:py-8 px-4 md:px-8
                relative
                ${index !== 0 ? "border-l-4 border-gray-100" : ""}
                transition-all duration-200 hover:scale-105
                group
              `}
              aria-label={text}
            >
              <div className="mb-4 md:mb-6">
                <Icon
                  className="w-12 h-12 md:w-16 md:h-16 text-guru-milk-chocolate 
                           transition-all duration-200 group-hover:text-blue-600"
                  strokeWidth={1.25}
                />
              </div>

              <span className="text-lg md:text-xl font-medium text-guru-milk-chocolate group-hover:text-blue-600">{text}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceFeatures;
